import React, { FormEvent, useContext, useEffect, useState } from 'react';
import { IDetailData } from '../detail-data';
import { Col, ControlLabel, FormControl, Glyphicon, Panel } from 'react-bootstrap';
import { PanelBodyWrapper, FormField } from '../styles';
import { Controller, useFormContext } from 'react-hook-form';
import { PatientIntakeContext } from '../context';

interface IProps {
    disableEdit: boolean
}

const Address = ({ disableEdit }: IProps) => {
    const context = useContext(PatientIntakeContext);
    const [open, setOpen] = useState(true);

    const { control, watch, formState: { errors } } = useFormContext<IDetailData>();
    const addressIsUs = watch('addressIsUs');

    return (
        <Panel expanded={open}>
            <Panel.Heading style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Panel.Title style={{ fontSize: 14, cursor: 'default' }} onClick={() => setOpen(!open)}>Address</Panel.Title>
                <Panel.Toggle onClick={() => setOpen(!open)}><Glyphicon glyph={open ? 'triangle-bottom' : 'triangle-top'} /></Panel.Toggle>
            </Panel.Heading>
            <Panel.Collapse>
                <PanelBodyWrapper>
                    <FormField>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>Address Type:</Col>
                        <Col xs={12} lg={8}>
                            <Controller
                                control={control}
                                name='addressIsUs'
                                render={({ field: { onChange, value } }) => (
                                    <FormControl
                                        componentClass='select'
                                        disabled={disableEdit}
                                        value={value}
                                        onChange={(e: FormEvent<FormControl & HTMLSelectElement>) => onChange(parseInt(e.currentTarget.value))}
                                    >
                                        <option value={1}>United States</option>
                                        <option value={0}>International</option>
                                    </FormControl>
                                )} />
                        </Col>
                    </FormField>
                    <FormField>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>Address Line 1:</Col>
                        <Col xs={12} lg={8}>
                            <Controller
                                control={control}
                                name='addressLine1'
                                render={({ field: { onChange, value } }) => (
                                    <FormControl
                                        type='text'
                                        disabled={disableEdit}
                                        value={value || ''}
                                        onChange={onChange}
                                    />
                                )} />
                        </Col>
                    </FormField>
                    <FormField>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>Address Line 2:</Col>
                        <Col xs={12} lg={8}>
                            <Controller
                                control={control}
                                name='addressLine2'
                                render={({ field: { onChange, value } }) => (
                                    <FormControl
                                        type='text'
                                        disabled={disableEdit}
                                        value={value || ''}
                                        onChange={onChange}
                                    />
                                )} />
                        </Col>
                    </FormField>
                    <FormField>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>City:</Col>
                        <Col xs={12} lg={8}>
                            <Controller
                                control={control}
                                name='city'
                                render={({ field: { onChange, value } }) => (
                                    <FormControl
                                        type='text'
                                        disabled={disableEdit}
                                        value={value || ''}
                                        onChange={onChange}
                                    />
                                )} />
                        </Col>
                    </FormField>

                    {addressIsUs === 1 ?
                        <FormField>
                            <Col xs={12} lg={4} componentClass={ControlLabel}>State:</Col>
                            <Col xs={12} lg={8}>
                                <Controller
                                    control={control}
                                    name='stateProvinceValue'
                                    render={({ field: { onChange, value } }) => (
                                        <FormControl
                                            componentClass='select'
                                            disabled={disableEdit}
                                            value={value}
                                            onChange={onChange}
                                        >
                                            <option value=''>- Select State -</option>
                                            {context.stateList.map(state => (
                                                <option key={'state=' + state.id} value={state.id.toString()}>{state.description}</option>
                                            ))}
                                        </FormControl>
                                    )} />
                            </Col>
                        </FormField>
                        :
                        <FormField>
                            <Col xs={12} lg={4} componentClass={ControlLabel}>Province/Region:</Col>
                            <Col xs={12} lg={8}>
                                <Controller
                                    control={control}
                                    name='stateProvinceValue'
                                    render={({ field: { onChange, value } }) => (
                                        <FormControl
                                            type='text'
                                            disabled={disableEdit}
                                            value={value || ''}
                                            onChange={onChange}
                                        />
                                    )} />
                            </Col>
                        </FormField>
                    }

                    <FormField>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>Postal Code:</Col>
                        <Col xs={12} lg={8}>
                            <Controller
                                control={control}
                                name='postalCode'
                                render={({ field: { onChange, value } }) => (
                                    <FormControl
                                        type='text'
                                        disabled={disableEdit}
                                        value={value || ''}
                                        onChange={onChange}
                                    />
                                )} />
                        </Col>
                    </FormField>
                </PanelBodyWrapper>
            </Panel.Collapse>
        </Panel>
    );
}

export default Address;